import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class SnackbarService {

  constructor(public snackBar: MatSnackBar) { }

  public info(msg: string) {
    this.snackBar.open(msg, "Zamknij", { duration: 5000 });
  } 

  public error(err: any) {
    this.snackBar.open(err.statusText, "Zamknij", { duration: 5000 });
    console.error(err)
  } 
}